module.exports = __webpack_public_path__ + "img/badge_thankam.a814df97.png";